import { ActionTree } from 'vuex';
import { RootState } from '../types';
import {
    CampaignState, ActionError,
    CurrentCampaignType,
    CurrentAdsetType,
} from './types';

interface ActionsType {
    SET_CURRENT_CAMPAIGN: ({ commit }: any, payload: CurrentCampaignType) => void;
    CLEAR_CURRENT_CAMPAIGN: ({ commit }: any) => void;
    SET_CURRENT_ADSET: ({ commit }: any, payload: CurrentAdsetType) => void;
    CLEAR_CURRENT_ADSET: ({ commit }: any) => void;
}

export const actions: ActionTree<CampaignState, RootState> & ActionsType = {
    SET_CURRENT_CAMPAIGN: async ({ commit }: any, payload: CurrentCampaignType) => {
        try {
            commit('SET_CURRENT_CAMPAIGN', payload);
        } catch (err) {
            err.type = ActionError.SET_CURRENT_CAMPAIGN;
            throw err;
        }
    },
    CLEAR_CURRENT_CAMPAIGN: async({commit}: any) => {
        try {
            commit('CLEAR_CURRENT_CAMPAIGN');            
        } catch (err) {
            err.type = ActionError.CLEAR_CURRENT_CAMPAIGN;
            throw err;
        }
    },
    SET_CURRENT_ADSET: async ({ commit }: any, payload: CurrentAdsetType) => {
        try {
            commit('SET_CURRENT_ADSET', payload);
        } catch (err) {
            err.type = ActionError.SET_CURRENT_ADSET;
            throw err;
        }
    },
    CLEAR_CURRENT_ADSET: async({commit}: any) => {
        try {
            commit('CLEAR_CURRENT_ADSET');            
        } catch (err) {
            err.type = ActionError.CLEAR_CURRENT_ADSET;
            throw err;
        }
    }
};
